
import Vue from 'vue'
import { CartPromoCodeViewModel } from '@ViewModels/CartPromoCodeViewModel'
import { Textbox } from '@/components/formGroups'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'PromoCodesComponent',
   data() {
      return {
         visible: false,
         submitting: false,
         promocodeText: '',
         errorMessage: '',
      }
   },
   computed: {
      promocodes(): CartPromoCodeViewModel {
         return this.$store.state.modelData.PromoCodes
      },
   },
   methods: {
      async applyPromocode() {
         this.errorMessage = ''
         if (this.promocodeText.length === 0) {
            return
         }

         this.submitting = true
         const result = await this.$store.dispatch('applyPromocode', this.promocodeText)
         if (result.Success) {
            this.promocodeText = ''
         } else {
            this.errorMessage = result.ErrorMessage
         }
         this.submitting = false
      },
   },
   components: {
      Textbox,
      SaveButton,
   },
})
